import OrdersList from './OrdersList.component';

export default OrdersList;
